import React, { useState, useEffect } from 'react'
import useRouter from 'utils/useRouter'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Card, CardHeader, CardContent, TextField, Grid } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import validate from 'validate.js'
import { useOrgaoService } from 'hooks/useOrgaoService'

const useStyles = makeStyles((theme) => ({
  root: {},
  alert: {
    marginBottom: theme.spacing(3),
  },
  formGroup: {
    marginBottom: theme.spacing(3),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  fieldHint: {
    margin: theme.spacing(1, 0),
  },
  tags: {
    marginTop: theme.spacing(1),
    '& > * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  dateField: {
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))

const schema = {
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  sigla: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  descricao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
}

export const Formulario = (props) => {
  const { className, dados, editar, ...rest } = props
  const orgaoService = useOrgaoService()
  const classes = useStyles()
  const router = useRouter()
  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  })

  useEffect(() => {
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        nome: dados.nome,
        sigla: dados.sigla,
        descricao: dados.descricao,
      },
    }))
    
  }, [dados])

  useEffect(() => {
    const errors = validate(formState.values, schema)

    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }))
  
  }, [formState.values])

  const handleChange = (event) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  const hasError = (field) => formState.touched[field] && formState.errors[field]

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (formState.isValid) {
      if (editar) {
        await orgaoService.editarOrgao(dados.id, formState.values)
      } else {
        await orgaoService.cadastrarOrgao(formState.values)
      }
      router.history.push('/orgaos')
    }
  }

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <form
          id="form-edit-orgao"
          onSubmit={handleSubmit}
          {...rest}
          className={clsx(classes.root, className)}
        >
          <Grid
            className={classes.fieldGroup}
            alignItems="center"
            container
            justify="space-between"
          >
            <Grid className={classes.item} item md={6} sm={6} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('nome')}
                  fullWidth
                  helperText={hasError('nome') ? formState.errors.nome[0] : null}
                  label="Nome do orgão"
                  name="nome"
                  rows={2}
                  onChange={handleChange}
                  value={formState.values.nome || ''}
                  required
                  multiline
                />
              </FormControl>
            </Grid>
            <Grid className={classes.item} item md={5} sm={5} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('sigla')}
                  fullWidth
                  helperText={hasError('sigla') ? formState.errors.sigla[0] : null}
                  label="Sigla"
                  name="sigla"
                  rows={2}
                  onChange={handleChange}
                  value={formState.values.sigla || ''}
                  required
                  multiline
                />
              </FormControl>
            </Grid>
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
                <TextField
                  error={hasError('descricao')}
                  fullWidth
                  helperText={hasError('descricao') ? formState.errors.descricao[0] : null}
                  label="Descrição"
                  name="descricao"
                  rows={2}
                  onChange={handleChange}
                  value={formState.values.descricao || ''}
                  required
                  multiline
                />
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </Card>
  )
}
